export enum LogicType {
    Simple,
    Advanced,
}
